<div id="_edit-dialog-shared_" class="flex flex-grow flex-col scrollbar-none">
  <div id="_modal-HEADER" class="flex flex-grow items-center justify-between modal-header">
    <div id="_icon-PageTitle_" class="flex items-center">
      <div id="_svgPurpleSaturn_" class="px-2 flex items-center justify-center">
        <ism-svg data-tooltip="Toggle Test Mode" class="tooltip-r" (click)="session.toggleISMtesting()" [name]="'saturnPurple'"></ism-svg>
      </div>
      <div class="w-11/12 text-left modal-title">{{ title() }}</div>
    </div>

    <div id="_Buttons" class="flex items-center justify-end">
      <button class="mx-2 px-4 btn" type="button" (click)="action.emit('save')">{{ okButtonLabel() }}</button>
      <button class="px-4 btn" type="button" (click)="action.emit('cancel')">Cancel</button>
    </div>
  </div>

  <ng-content select="[edit-body]"></ng-content>

  <div id="_modal-FOOTER" class="flex items-center justify-end modal-footer">
    <div class="flex items-center justify-end">
      <button class="mx-2 px-4 btn" type="button" (click)="action.emit('save')">{{ okButtonLabel() }}</button>
      <button class="px-4 btn" type="button" (click)="action.emit('cancel')">Cancel</button>
    </div>
  </div>
</div>
